// extracted by mini-css-extract-plugin
export var aircallIframe = "_d0-3";
export var fabContainer = "_d0-5";
export var fabRinging = "_d0-6";
export var loadingOverlay = "_d0-4";
export var pulse = "_d0-7";
export var widgetContent = "_d0-2";
export var widgetPanel = "_d0-0";
export var widgetPanelExpanded = "_d0-1";